import { render, staticRenderFns } from "./listaPedidoCompra.vue?vue&type=template&id=28072ae8&scoped=true&"
import script from "./listaPedidoCompra.vue?vue&type=script&lang=js&"
export * from "./listaPedidoCompra.vue?vue&type=script&lang=js&"
import style0 from "./listaPedidoCompra.vue?vue&type=style&index=0&id=28072ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28072ae8",
  null
  
)

export default component.exports